module.exports = __webpack_public_path__ + "static/img/jst_login.51a159d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jushuitan/jst_login.png
// module id = 1343
// module chunks = 0